module.exports = __webpack_public_path__ + "03_glasses_brown.b32ed884.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer4/03_glasses_brown.png
// module id = ysXG
// module chunks = 0